import React, { Suspense } from 'react';
import { Box, CircularProgress, IconButton, Tooltip, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

class PageLoadBoundary extends React.Component<React.PropsWithChildren, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (this.state.failed) {
      return (
        <Box role="alert" sx={{ minHeight: 240, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, p: 3 }}>
          <Typography>页面暂时无法打开</Typography>
          <Tooltip title="刷新页面">
            <IconButton aria-label="刷新页面" onClick={() => window.location.reload()}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </Box>
      );
    }
    return (
      <Suspense fallback={
        <Box role="status" aria-label="正在加载页面" sx={{ minHeight: 240, display: 'grid', placeItems: 'center' }}>
          <CircularProgress size={28} />
        </Box>
      }>
        {this.props.children}
      </Suspense>
    );
  }
}

export default PageLoadBoundary;
